import { Injectable } from '@angular/core';

import { FirestoreService } from '@msi/core/dao/firebase/firestore';

import { BfitNetwork } from './entities/bfit-network';
import { BfitOrganization } from './bfit-organizations';
import { Observable, of } from 'rxjs';
import { DBService } from '@msi/core/dao/db';

export * from './entities/bfit-network';


@Injectable({ providedIn: 'root' })
export class BfitNetworksService extends DBService<BfitNetwork> {

    constructor(db: FirestoreService) {
        super('bfit_networks', db);
    }

    findAllForOrganization(org: BfitOrganization): Observable<BfitNetwork[]> {
        return org ? super.getAll(ref => ref.where('bfit_org_ref.id', '==', org.id)) : of([]);
    }

}
